module.exports = __webpack_public_path__ + "media/images/odoughsLogo-7e36ea2d.jpeg";